import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Truck, Shield, FileText, MessageSquare, ClipboardList } from 'lucide-react';

const CargoCareMenu = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#3D3F42]">
      {/* Header */}
      <div className="sticky top-0 bg-[#2A2B2E] shadow-sm z-10 p-4">
        <div className="flex items-center gap-4">
          <button
            onClick={() => navigate(-1)}
            className="p-2 hover:bg-gray-700 rounded-lg"
          >
            <ArrowLeft className="w-6 h-6 text-white" />
          </button>
          <div>
            <h1 className="text-xl font-semibold text-white">CargoCare</h1>
            <p className="text-sm text-gray-400">Cargo inspection and management tools</p>
          </div>
        </div>
      </div>

      {/* Menu Grid */}
      <div className="p-6 grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="bg-[#2A2B2E] rounded-lg p-6 hover:bg-[#353639] transition-colors cursor-pointer" onClick={() => navigate('/cargocare/inspection')}>
          <div className="flex items-center gap-3 mb-2">
            <div className="p-3 bg-blue-500/10 rounded-lg">
              <Truck className="w-6 h-6 text-blue-500" />
            </div>
            <h2 className="text-lg font-medium text-white">Cargo Inspection</h2>
          </div>
          <p className="text-gray-400 ml-12">Document cargo condition and details</p>
        </div>

        <div className="bg-[#2A2B2E] rounded-lg p-6 hover:bg-[#353639] transition-colors cursor-pointer" onClick={() => navigate('/cargocare/damage')}>
          <div className="flex items-center gap-3 mb-2">
            <div className="p-3 bg-red-500/10 rounded-lg">
              <Shield className="w-6 h-6 text-red-500" />
            </div>
            <h2 className="text-lg font-medium text-white">Damage Assessment</h2>
          </div>
          <p className="text-gray-400 ml-12">Record and report cargo damage</p>
        </div>

        <div className="bg-[#2A2B2E] rounded-lg p-6 hover:bg-[#353639] transition-colors cursor-pointer" onClick={() => navigate('/cargocare/safety')}>
          <div className="flex items-center gap-3 mb-2">
            <div className="p-3 bg-green-500/10 rounded-lg">
              <ClipboardList className="w-6 h-6 text-green-500" />
            </div>
            <h2 className="text-lg font-medium text-white">Safety Compliance</h2>
          </div>
          <p className="text-gray-400 ml-12">Ensure cargo meets safety standards</p>
        </div>

        <div className="bg-[#2A2B2E] rounded-lg p-6 hover:bg-[#353639] transition-colors cursor-pointer" onClick={() => navigate('/cargocare/documentation')}>
          <div className="flex items-center gap-3 mb-2">
            <div className="p-3 bg-yellow-500/10 rounded-lg">
              <FileText className="w-6 h-6 text-yellow-500" />
            </div>
            <h2 className="text-lg font-medium text-white">Digital Documentation</h2>
          </div>
          <p className="text-gray-400 ml-12">Manage cargo documents and certificates</p>
        </div>

        <div className="bg-[#2A2B2E] rounded-lg p-6 hover:bg-[#353639] transition-colors cursor-pointer" onClick={() => navigate('/cargocare/reports')}>
          <div className="flex items-center gap-3 mb-2">
            <div className="p-3 bg-purple-500/10 rounded-lg">
              <FileText className="w-6 h-6 text-purple-500" />
            </div>
            <h2 className="text-lg font-medium text-white">Interactive Reports</h2>
          </div>
          <p className="text-gray-400 ml-12">Generate and view cargo reports</p>
        </div>

        <div className="bg-[#2A2B2E] rounded-lg p-6 hover:bg-[#353639] transition-colors cursor-pointer" onClick={() => navigate('/cargocare/team')}>
          <div className="flex items-center gap-3 mb-2">
            <div className="p-3 bg-indigo-500/10 rounded-lg">
              <MessageSquare className="w-6 h-6 text-indigo-500" />
            </div>
            <h2 className="text-lg font-medium text-white">Team Communication</h2>
          </div>
          <p className="text-gray-400 ml-12">Collaborate with your team</p>
        </div>
      </div>

      {/* Footer */}
      <div className="fixed bottom-0 left-0 right-0 bg-[#2A2B2E] p-3 text-center text-gray-400 text-xs">
        Powered by Soltec - Version 6.0
      </div>
    </div>
  );
};

export default CargoCareMenu;
export { CargoCareMenu };